import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18Zm3.68 5.418c-.339.006-.858.187-3.358 1.227-.875.364-2.624 1.117-5.248 2.26-.426.17-.65.335-.67.497-.039.311.41.408.973.591.46.15 1.077.324 1.398.331.292.007.618-.114.977-.36 2.448-1.653 3.714-2.489 3.796-2.509.056-.013.134-.029.186.018.053.046.048.135.042.159-.044.19-2.347 2.285-2.48 2.423-.505.526-1.082.847-.194 1.432.77.507 1.217.83 2.01 1.35.505.332.903.725 1.425.677.24-.023.488-.25.614-.923.299-1.594.885-5.047 1.02-6.47a1.587 1.587 0 0 0-.015-.354.379.379 0 0 0-.128-.245.592.592 0 0 0-.348-.104Z"
    />
  </svg>
`;
